import axiosHttpRequest from "../axios"

async function getJobTrackingDetails(endpoint, queryparams, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);
    console.log(serviceResponse, "serviceResponse")
    let serviceData = serviceResponse.data;
    let listViewData = [];
    let listViewInfo = {};
    console.log(serviceData,"servicedata1")
    if (serviceData.issuccess ==1 && serviceData.Records) {
        listViewData = serviceData.Records;
    }else{
        listViewData.message= serviceData.message
    }
    listViewInfo.records = listViewData;
    return listViewData;
}


export default {
    getJobTrackingDetails,
}